var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfitability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008d75",
    d: "M256 150.16L246 262h25V140.16z",
    "data-original": "#008d75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2db37f",
    d: "M241 140.16V262h15V150.16z",
    "data-original": "#2db37f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    d: "M256 150c82.843 0 150-67.157 150-150-82.843 0-150 67.157-150 150z",
    "data-original": "#00a085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ac779",
    d: "M106 0c0 82.843 67.157 150 150 150C256 67.157 188.843 0 106 0z",
    "data-original": "#5ac779"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M406 444.5l-10 33.75L406 512h30v-67.5z",
    "data-original": "#ff7452"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M376 444.5l-10 33.75L376 512h30v-67.5z",
    "data-original": "#fb9d46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M346 424.5l-10 53.75L346 512h30v-87.5z",
    "data-original": "#ff7452"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M316 424.5l-10 53.75L316 512h30v-87.5z",
    "data-original": "#fb9d46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M286 424.5l-10 53.75L286 512h30v-87.5z",
    "data-original": "#ff7452"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M256 424.5l-10 53.75L256 512h30v-87.5z",
    "data-original": "#fb9d46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M226 424.5l-10 53.75L226 512h30v-87.5z",
    "data-original": "#fdba4c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M196 424.5l-10 53.75L196 512h30v-87.5z",
    "data-original": "#fb9d46"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M166 424.5l-10 53.75L166 512h30v-87.5z",
    "data-original": "#fdba4c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M136 424.5l-10 53.75L136 512h30v-87.5z",
    "data-original": "#fb9d46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M106 424.5h30V512h-30z",
    "data-original": "#fdba4c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M436 309.5l-10 33.75L436 377h30v-67.5z",
    "data-original": "#fb9d46"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M406 289.5l-10 53.75L406 377h30v-67.5z",
    "data-original": "#ff7452"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M376 289.5l-10 53.75L376 377h30v-87.5z",
    "data-original": "#fb9d46"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M346 289.5l-10 53.75L346 397h30V289.5z",
    "data-original": "#ff7452"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M316 289.5l-10 53.75L316 397h30V289.5z",
    "data-original": "#fb9d46"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M286 289.5l-10 53.75L286 397h30V289.5z",
    "data-original": "#ff7452"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M256 289.5l-10 53.75L256 397h30V289.5z",
    "data-original": "#fb9d46"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M226 289.5l-10 53.75L226 397h30V289.5z",
    "data-original": "#fdba4c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M196 289.5l-10 53.75L196 397h30V289.5z",
    "data-original": "#ffd652"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M166 289.5l-10 53.75L166 397h30V289.5z",
    "data-original": "#fdba4c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M136 289.5h30V397h-30z",
    "data-original": "#ffd652"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M406 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fb9d46"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M376 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fdba4c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M346 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fb9d46"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M316 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fdba4c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M286 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fb9d46"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M256 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fdba4c"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M226 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#ffd652"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M196 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fbe287"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M166 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#ffd652"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M136 242l-10 33.75 10 33.75h30V242z",
    "data-original": "#fbe287"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M106 242h30v67.5h-30z",
    "data-original": "#ffd652"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M346 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fb9d46"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M316 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fdba4c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M286 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fb9d46"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M256 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fdba4c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M226 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#ffd652"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M196 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fbe287"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M166 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#ffd652"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M136 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fbe287"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M106 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#ffd652"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a085",
    fillOpacity: 1,
    d: "M76 377l-10 33.75 10 33.75h30V377z",
    "data-original": "#fbe287"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M46 377h30v67.5H46z",
    "data-original": "#ffd652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitability);
export default __webpack_public_path__ + "static/media/profitability.c5e5dffffc5147686dda58c6f10d303f.svg";
export { ForwardRef as ReactComponent };